// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.GoodScroll{
    /*border: 1px solid;*/
    flex-shrink: 0;
    height: 100%;
    --scrollSize: 10px;
    --additionalShift: 17px;
    --gradientColor: #f9f9f6;
    --gradientEmptyColor: #f9f9f600;
    position: relative;
}

.GoodScroll_relativeSizer{
    height: 100%;
    overflow: hidden;
    position: relative;
}

.GoodScroll_realScroll{
    overflow: scroll;
    height: calc(100% + var(--scrollSize) + var(--additionalShift));
    width: calc(100% + var(--scrollSize) + var(--additionalShift));
}

.GoodScroll_content_zero{
    height: calc(100% - 0px);
    width: calc(100% - 0px);
}

.GoodScroll_content{
    padding-right: var(--additionalShift);
    padding-bottom: var(--additionalShift);
}

.GoodScroll_visualScroll{
    position: absolute;
    height: 100%;
    top: 0px;
    right: 0;
    width: 11px;
    padding: 10px 0px;
    opacity: 0.0;
    transition: opacity 1000ms;
}

.GoodScroll_visualScroll_bar{
    position: relative;
    user-select: none;
    top: 17.5422%;
    height: 49.3976%;
    padding: 0px 2px;
}

.GoodScroll_visualScroll_bar_colored{
    display: none;
    border-radius: 5px;
    background-color: rgb(153, 153, 153);
    height: 100%;
    width: 100%;
}

.GoodScroll_gradient{
    position: absolute;
    height: 10px;
    width: 100%;
}

.GoodScroll_gradient_top{
    top: 0;
    left: 0;
    background-image: linear-gradient(180deg, var(--gradientColor) 0%, var(--gradientEmptyColor) 100%);
}

.GoodScroll_gradient_bottom{
    bottom: 0;
    left: 0;
    background-image: linear-gradient(0deg, var(--gradientColor) 0%, var(--gradientEmptyColor) 100%);
}

.GoodScroll--hover .GoodScroll_visualScroll{
    opacity: 1;
    transition: opacity 300ms;
}
`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/GoodScroll.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,+DAA+D;IAC/D,8DAA8D;AAClE;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,MAAM;IACN,OAAO;IACP,kGAAkG;AACtG;;AAEA;IACI,SAAS;IACT,OAAO;IACP,gGAAgG;AACpG;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B","sourcesContent":["\n.GoodScroll{\n    /*border: 1px solid;*/\n    flex-shrink: 0;\n    height: 100%;\n    --scrollSize: 10px;\n    --additionalShift: 17px;\n    --gradientColor: #f9f9f6;\n    --gradientEmptyColor: #f9f9f600;\n    position: relative;\n}\n\n.GoodScroll_relativeSizer{\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n}\n\n.GoodScroll_realScroll{\n    overflow: scroll;\n    height: calc(100% + var(--scrollSize) + var(--additionalShift));\n    width: calc(100% + var(--scrollSize) + var(--additionalShift));\n}\n\n.GoodScroll_content_zero{\n    height: calc(100% - 0px);\n    width: calc(100% - 0px);\n}\n\n.GoodScroll_content{\n    padding-right: var(--additionalShift);\n    padding-bottom: var(--additionalShift);\n}\n\n.GoodScroll_visualScroll{\n    position: absolute;\n    height: 100%;\n    top: 0px;\n    right: 0;\n    width: 11px;\n    padding: 10px 0px;\n    opacity: 0.0;\n    transition: opacity 1000ms;\n}\n\n.GoodScroll_visualScroll_bar{\n    position: relative;\n    user-select: none;\n    top: 17.5422%;\n    height: 49.3976%;\n    padding: 0px 2px;\n}\n\n.GoodScroll_visualScroll_bar_colored{\n    display: none;\n    border-radius: 5px;\n    background-color: rgb(153, 153, 153);\n    height: 100%;\n    width: 100%;\n}\n\n.GoodScroll_gradient{\n    position: absolute;\n    height: 10px;\n    width: 100%;\n}\n\n.GoodScroll_gradient_top{\n    top: 0;\n    left: 0;\n    background-image: linear-gradient(180deg, var(--gradientColor) 0%, var(--gradientEmptyColor) 100%);\n}\n\n.GoodScroll_gradient_bottom{\n    bottom: 0;\n    left: 0;\n    background-image: linear-gradient(0deg, var(--gradientColor) 0%, var(--gradientEmptyColor) 100%);\n}\n\n.GoodScroll--hover .GoodScroll_visualScroll{\n    opacity: 1;\n    transition: opacity 300ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
